declare namespace $ {

	type $mol_view__sub_shm_projects_timeline_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__hint_shm_projects_timeline_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__dictionary_shm_projects_timeline_3 = $mol_type_enforce<
		ReturnType< $shm_projects_timeline['week_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_projects_timeline_4 = $mol_type_enforce<
		ReturnType< $shm_projects_timeline['week'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__event_shm_projects_timeline_5 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_projects_timeline['week_select_pointerdown'] > ): ReturnType< $shm_projects_timeline['week_select_pointerdown'] >,
		})  & ReturnType< $mol_select['event'] >
		,
		ReturnType< $mol_select['event'] >
	>
	type $mol_view__sub_shm_projects_timeline_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_timeline_7 = $mol_type_enforce<
		ReturnType< $shm_projects_timeline['timeline_day_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_projects_digest_view__digest_shm_projects_timeline_8 = $mol_type_enforce<
		ReturnType< $shm_projects_timeline['week_summary'] >
		,
		ReturnType< $shm_projects_digest_view['digest'] >
	>
	type $shm_projects_digest_view__refresh_shm_projects_timeline_9 = $mol_type_enforce<
		ReturnType< $shm_projects_timeline['refresh_week'] >
		,
		ReturnType< $shm_projects_digest_view['refresh'] >
	>
	type $mol_view__sub_shm_projects_timeline_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_projects_timeline_11 = $mol_type_enforce<
		({ 
			'today': ReturnType< $shm_projects_timeline['timeline_day_today'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_projects_timeline_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_timeline_13 = $mol_type_enforce<
		ReturnType< $shm_projects_timeline['timeline_event_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_projects_timeline_14 = $mol_type_enforce<
		({ 
			'today': ReturnType< $shm_projects_timeline['timeline_day_today'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_projects_timeline_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_projects_digest_day__text_shm_projects_timeline_16 = $mol_type_enforce<
		ReturnType< $shm_projects_timeline['day_summary'] >
		,
		ReturnType< $shm_projects_digest_day['text'] >
	>
	type $shm_projects_digest_day__refresh_shm_projects_timeline_17 = $mol_type_enforce<
		ReturnType< $shm_projects_timeline['refresh_day'] >
		,
		ReturnType< $shm_projects_digest_day['refresh'] >
	>
	type $mol_link__arg_shm_projects_timeline_18 = $mol_type_enforce<
		ReturnType< $shm_projects_timeline['timeline_event_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_shm_projects_timeline_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_projects_timeline_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_projects_timeline extends $mol_view {
		Timeline_title( ): $mol_view
		week_options( ): Record<string, any>
		week( next?: string ): string
		week_select_pointerdown( next?: any ): any
		Week_select( ): $mol_select
		Timeline_head( ): $mol_view
		timeline_day_rows( ): readonly($mol_view)[]
		Timeline_days( ): $mol_view
		week_summary( ): any
		refresh_week( next?: any ): any
		Week_summary( ): $shm_projects_digest_view
		Timeline_content( ): $mol_view
		timeline_day_today( id: any): boolean
		timeline_day_title( id: any): string
		Timeline_day_title( id: any): $mol_view
		timeline_event_rows( id: any): readonly($mol_view)[]
		Timeline_events( id: any): $mol_view
		day_summary_rows( id: any): readonly($mol_view)[]
		day_summary( id: any): string
		refresh_day( id: any, next?: any ): any
		timeline_event_arg( id: any): Record<string, any>
		timeline_event_title( id: any): string
		sub( ): readonly(any)[]
		Timeline_day( id: any): $mol_view
		Day_summary( id: any): $shm_projects_digest_day
		Timeline_event( id: any): $mol_link
		Timeline_empty( id: any): $mol_view
	}
	
}

//# sourceMappingURL=timeline.view.tree.d.ts.map